import React from "react";
import { SliceComponentProps } from "@prismicio/react";

import { AVAILABLE_LANGS } from "@typings/globals";

import { Row } from "@ui/Atoms";
import { Variant } from "@ui/Atoms/Button";

import { useTelemetry } from "@hooks/useTelemetry";

import {
  PrismicLandingPageV2DataBodyCalltoactionbuttons,
  PrismicLandingPageV2DataBodyCalltoactionbuttonsItem,
} from "@www/graphql-types";

import { useProceedRedirect } from "../../LandingPageV2.helper";

import * as Styled from "./CallToActionButtons.styled";

export const CallToActionButtons = ({
  slice,
  context,
}: SliceComponentProps<
  PrismicLandingPageV2DataBodyCalltoactionbuttons,
  { language: AVAILABLE_LANGS; prismicPageId: string }
>) => {
  const buttons = slice.items;
  const redirect = useProceedRedirect();
  const { elementClick } = useTelemetry();

  const handleClick =
    (
      button: PrismicLandingPageV2DataBodyCalltoactionbuttonsItem,
      index: number,
    ) =>
    () => {
      elementClick(button.button_text.text || "", {
        buttonId: "call_to_action_button_" + index,
        context: {
          prismicPageId: context.prismicPageId,
        },
      });

      redirect(
        context.language,
        button.redirect_on_click_url,
        !!button.requires_authorization,
      );
    };

  return (
    <Styled.Root>
      <Row>
        <Styled.Actions>
          {buttons.map((button, index) => {
            return (
              <Styled.ActionBtn
                key={index}
                variant={
                  button.button_variant === null
                    ? undefined
                    : (button.button_variant as Variant)
                }
                onClick={handleClick(button, index)}
              >
                {button.button_text.text}
              </Styled.ActionBtn>
            );
          })}
        </Styled.Actions>
      </Row>
    </Styled.Root>
  );
};
